// extracted by mini-css-extract-plugin
export default {"container":"SpringDealBanner-module__container___R1uAn"};